import { useTranslation } from "react-i18next";
import { Cell, Legend, Pie, PieChart, Tooltip } from "recharts";

import { CustomizedPieLabel } from "modules/LocationReports/components";
import "modules/LocationReports/components/SimplePieChart/SimplePieChart.scss";
import { REPORTS_COLORS } from "utils/common";

import type { ReportColor } from "models";

type SimplePieChartProps = {
  data: Record<string, string>[];
  colors: ReportColor[];
};

export const SimplePieChart = ({ data, colors }: SimplePieChartProps) => {
  const { t } = useTranslation();

  const renderLegend = () => {
    const maxItemsPerColumn = 15;
    const numberOfColumns = Math.ceil(data.length / maxItemsPerColumn);

    return (
      <ul className="simple-pie-chart-legend" style={{ gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)` }}>
        {data.map((entry, index) => (
          <li
            key={`item-${index}`}
            style={{ color: colors.find(col => (t(col.name) || col.name) === entry.name)?.color || REPORTS_COLORS[index % REPORTS_COLORS.length] }}
          >
            {entry.name}
          </li>
        ))}
      </ul>
    );
  };
  const reportColors = data.map((entry, index) => {
    return colors.find(col => (t(`v8_${col.name}`) || col.name) === entry.name)?.color || REPORTS_COLORS[index % REPORTS_COLORS.length];
  });

  return (
    <PieChart width={1300} height={400} className="SimplePieChart">
      <Pie
        data={data}
        cx={400}
        cy={175}
        outerRadius={120}
        labelLine={false}
        label={props => <CustomizedPieLabel {...props} colors={reportColors} />}
        fill="#8884d8"
        dataKey="value"
        style={{ outline: "none" }}
      >
        {data.map((entry, index) => (
          <Cell key={index} fill={colors.find(col => (t(`v8_${col.name}`) || col.name) === entry.name)?.color || REPORTS_COLORS[index % REPORTS_COLORS.length]} />
        ))}
      </Pie>
      <Legend verticalAlign="middle" align="right" layout="vertical" content={renderLegend} />
      <Tooltip />
    </PieChart>
  );
};
